import { render } from "./BaseSliderItem.vue?vue&type=template&id=8c77bdb4&scoped=true"
import script from "./BaseSliderItem.vue?vue&type=script&lang=js"
export * from "./BaseSliderItem.vue?vue&type=script&lang=js"

import "./BaseSliderItem.vue?vue&type=style&index=0&id=8c77bdb4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c77bdb4"

export default script